class RhodeMegaMenu extends HTMLElement {
  connectedCallback() {
    this.tabs = this.querySelectorAll('[data-rmm-tab]');
    this.panels = this.querySelectorAll('[data-rmm-panel]');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.rmmTab));
    });
    this.querySelectorAll('[data-rmm-next]').forEach((b) => b.addEventListener('click', (e) => this.scrollTrack(e, 1)));
    this.querySelectorAll('[data-rmm-prev]').forEach((b) => b.addEventListener('click', (e) => this.scrollTrack(e, -1)));

    this.panels.forEach((panel) => {
      const track = panel.querySelector('[data-rmm-track]');
      if (!track) return;
      track.addEventListener('scroll', () => this.updateArrows(panel), { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => this.updateArrows(panel)).observe(track);
      }
    });

    const navItem = this.closest('.nav-item');
    if (navItem) navItem.addEventListener('mouseenter', () => this.panels.forEach((p) => this.updateArrows(p)));
  }

  activate(index) {
    this.tabs.forEach((t) => {
      const on = t.dataset.rmmTab === index;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.panels.forEach((p) => {
      const on = p.dataset.rmmPanel === index;
      p.classList.toggle('is-active', on);
      if (on) this.updateArrows(p);
    });
  }

  scrollTrack(e, dir) {
    const panel = e.currentTarget.closest('[data-rmm-panel]');
    const track = panel && panel.querySelector('[data-rmm-track]');
    if (!track) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    let target = track.scrollLeft + dir * track.clientWidth * 0.85;
    if (dir > 0 && target >= maxScroll - track.clientWidth * 0.3) {
      target = maxScroll;
    } else if (dir < 0 && target <= track.clientWidth * 0.3) {
      target = 0;
    }
    track.scrollTo({ left: target, behavior: 'smooth' });
  }

  updateArrows(panel) {
    const track = panel.querySelector('[data-rmm-track]');
    const prev = panel.querySelector('[data-rmm-prev]');
    const next = panel.querySelector('[data-rmm-next]');
    if (!track || !prev || !next) return;
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    prev.hidden = atStart;
    next.hidden = atEnd || track.scrollWidth <= track.clientWidth;
  }
}
if (!customElements.get('rhode-mega-menu')) customElements.define('rhode-mega-menu', RhodeMegaMenu);

/* ===== Items del nav con submenu ("Shop", "Brands"): tocar/clickear el
   titulo SOLO abre/cierra el submenu, nunca navega al link del padre.
   Se hace por delegacion en document (fase de captura) para que funcione
   aunque el header se re-renderice, en desktop, tablet y en touch. ===== */
(function () {
  function closeAllDesktop(except) {
    document.querySelectorAll('.site-navbar-main-wrapper .nav-item.active').forEach(function (i) {
      if (i !== except) i.classList.remove('active');
    });
  }

  document.addEventListener('click', function (e) {
    /* --- Nav desktop / tablet --- */
    var link = e.target.closest('.site-navbar-main-wrapper .nav-item > .menu-link');
    if (link) {
      var item = link.closest('.nav-item');
      var dropdown = item && item.querySelector(':scope > .megamenu-main--wrapper, :scope > .dropdown-menu--wrapper');
      if (dropdown) {
        e.preventDefault();
        e.stopPropagation();
        var wasOpen = item.classList.contains('active');
        closeAllDesktop(item);
        item.classList.toggle('active', !wasOpen);
        return;
      }
    }

    /* --- Cajon mobile: el <a> dentro del <summary> no debe navegar --- */
    var mobileLink = e.target.closest('.mobile-menu-slide-dropdown-detail > summary > a');
    if (mobileLink) {
      e.preventDefault();
      /* dejamos que el <summary> haga su toggle normal (abre el submenu) */
      var summary = mobileLink.closest('summary');
      var details = summary && summary.closest('details');
      if (details) {
        details.open = !details.open;
        var container = details.closest('[data-child-items]');
        if (container) container.classList.toggle('active', details.open);
      }
      return;
    }

    if (!e.target.closest('.site-navbar-main-wrapper')) closeAllDesktop(null);
  }, true);
})();
